import * as Yup from "yup";
export const resetPasswordSchema = Yup.object().shape({
  new_password: Yup.string().required("password is required").min(4, "Password must have at least 4 charactes"),
  confirm_new_password: Yup.string()
    .required("This field is required!")
    .oneOf([Yup.ref("new_password"), null], "passwords must match"),
});
